import type { PaymentStatus } from '~entities/payment';

import type { AbstractOption } from '~shared/types/abstract-options';

const options = [
  {
    title: 'In progress',
    value: 'IN_PROGRESS',
    checkmarkStyle: 'checkbox',
  },
  {
    title: 'Settled',
    value: 'SETTLED',
    checkmarkStyle: 'checkbox',
  },
] as const;

export const paymentStatusOptions =
  options as any as AbstractOption<PaymentStatus>[];
export type PaymentStatusValue = (typeof options)[number]['value'];
